import type { AnamnesisPipelineTimingMetrics } from './telemetry-metadata'

export const runTelemetrySafely = (fn: () => void): void => {
  try {
    fn()
  } catch {
    /* observabilidade nunca bloqueia consulta */
  }
}

export const runTelemetrySafelyAsync = async (fn: () => Promise<void>): Promise<void> => {
  try {
    await fn()
  } catch {
    /* observabilidade nunca bloqueia consulta */
  }
}

export const buildPipelineTimingMetrics = (parts: {
  uploadMs?: number
  sttMs?: number
  diarizationMs?: number
  aiMs?: number
  endToEndMs?: number
}): AnamnesisPipelineTimingMetrics => {
  const upload_ms = parts.uploadMs
  const stt_ms = parts.sttMs
  const diarization_ms = parts.diarizationMs
  const ai_ms = parts.aiMs
  const end_to_end_ms = parts.endToEndMs
  const segments = [upload_ms, stt_ms, diarization_ms, ai_ms].filter(
    (v): v is number => typeof v === 'number' && Number.isFinite(v),
  )
  const total_pipeline_ms =
    segments.length > 0 ? segments.reduce((sum, value) => sum + value, 0) : undefined
  return {
    ...(upload_ms != null ? { upload_ms } : {}),
    ...(stt_ms != null ? { stt_ms } : {}),
    ...(diarization_ms != null ? { diarization_ms } : {}),
    ...(ai_ms != null ? { ai_ms } : {}),
    ...(total_pipeline_ms != null ? { total_pipeline_ms } : {}),
    ...(end_to_end_ms != null ? { end_to_end_ms } : {}),
  }
}

export const createPerformanceTimer = (): { elapsedMs: () => number } => {
  const startedAt = performance.now()
  return {
    elapsedMs: () => Math.max(0, Math.round(performance.now() - startedAt)),
  }
}
